import { createSlice } from '@reduxjs/toolkit'
import {
  getOrders,
  saveOrder,
  createOrder,
  deleteOrder,
  addToCart,
  removeFromCart,
  emptyCart,
  getCart,
  addToCalc,
  removeFromCalc,
  emptyCalc,
  getCalc,
} from './orderActions'

const initialState = {
  orders: [],
  cart: [],
  calc: [],
  loading: false,
  error: false,
  loaded: false,
  cartLoaded: false,
  calcLoaded: false,
  saving: false,
  saved: false,
  cartSaved: false,
  calcSaved: false,
  savedOrder: {},
  deleting: false,
  deleted: false,
}

/*function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}*/

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    clear: (state) => {
      state.loading = false
      state.loaded = false
      state.cartLoaded = false
      state.calcLoaded = false

      state.saving = false
      state.error = false
      state.saved = false
      state.cartSaved = false
      state.calcSaved = false
      state.savedOrder = {}

      state.deleting = false
      state.deleted = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getOrders.fulfilled, (state, { payload }) => {
        state.loading = false
        state.loaded = true
        state.error = null
        state.orders = payload
      })
      .addCase(getOrders.pending, (state) => {
        state.loading = true
        state.loaded = false
        state.error = null
      })
      .addCase(getOrders.rejected, (state, { payload }) => {
        state.loading = false
        state.loaded = false
        state.error = payload
      })
      .addCase(saveOrder.pending, (state) => {
        state.saving = true
        state.error = null
        state.saved = false
      })
      .addCase(saveOrder.fulfilled, (state, { payload }) => {
        state.error = null
        state.savedOrder = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveOrder.rejected, (state, { payload }) => {
        state.saving = false
        state.error = payload
        state.saved = false
      })
      .addCase(createOrder.pending, (state) => {
        state.saving = true
        state.error = null
        state.saved = false
      })
      .addCase(createOrder.fulfilled, (state, { payload }) => {
        state.error = null
        state.savedOrder = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createOrder.rejected, (state, { payload }) => {
        state.saving = false
        state.error = payload
        state.saved = false
      })
      .addCase(deleteOrder.pending, (state) => {
        state.deleting = true
        state.error = null
        state.deleted = false
      })
      .addCase(deleteOrder.fulfilled, (state) => {
        state.error = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteOrder.rejected, (state, { payload }) => {
        state.deleting = false
        state.error = payload
        state.deleted = false
      })
      .addCase(addToCart.pending, (state) => {
        state.saving = true
        state.error = null
        state.cartSaved = false
      })
      .addCase(addToCart.fulfilled, (state) => {
        state.saving = false
        state.error = null
        state.cartSaved = true
      })
      .addCase(addToCart.rejected, (state, { payload }) => {
        state.saving = false
        state.error = payload
        state.cartSaved = false
      })
      .addCase(removeFromCart.pending, (state) => {
        state.deleting = true
        state.error = null
        state.deleted = false
      })
      .addCase(removeFromCart.fulfilled, (state) => {
        state.deleting = false
        state.error = null
        state.deleted = true
      })
      .addCase(removeFromCart.rejected, (state, { payload }) => {
        state.deleting = false
        state.error = payload
        state.deleted = false
      })
      .addCase(getCart.fulfilled, (state, { payload }) => {
        state.loading = false
        state.cartLoaded = true
        state.error = null
        state.cart = payload
      })
      .addCase(getCart.pending, (state) => {
        state.loading = true
        state.cartLoaded = false
        state.error = null
      })
      .addCase(getCart.rejected, (state, { payload }) => {
        state.loading = false
        state.cartLoaded = false
        state.error = payload
      })
      .addCase(emptyCart.pending, (state) => {
        state.deleting = true
        state.error = null
        state.deleted = false
      })
      .addCase(emptyCart.fulfilled, (state) => {
        state.deleting = false
        state.error = null
        state.deleted = true
      })
      .addCase(emptyCart.rejected, (state, { payload }) => {
        state.deleting = false
        state.error = payload
        state.deleted = false
      })
      .addCase(addToCalc.pending, (state) => {
        state.saving = true
        state.error = null
        state.calcSaved = false
      })
      .addCase(addToCalc.fulfilled, (state) => {
        state.saving = false
        state.error = null
        state.calcSaved = true
      })
      .addCase(addToCalc.rejected, (state, { payload }) => {
        state.saving = false
        state.error = payload
        state.calcSaved = false
      })
      .addCase(removeFromCalc.pending, (state) => {
        state.deleting = true
        state.error = null
        state.deleted = false
      })
      .addCase(removeFromCalc.fulfilled, (state) => {
        state.deleting = false
        state.error = null
        state.deleted = true
      })
      .addCase(removeFromCalc.rejected, (state, { payload }) => {
        state.deleting = false
        state.error = payload
        state.deleted = false
      })
      .addCase(getCalc.fulfilled, (state, { payload }) => {
        state.loading = false
        state.calcLoaded = true
        state.error = null
        state.calc = payload
      })
      .addCase(getCalc.pending, (state) => {
        state.loading = true
        state.calcLoaded = false
        state.error = null
      })
      .addCase(getCalc.rejected, (state, { payload }) => {
        state.loading = false
        state.calcLoaded = false
        state.error = payload
      })
      .addCase(emptyCalc.pending, (state) => {
        state.deleting = true
        state.error = null
        state.deleted = false
      })
      .addCase(emptyCalc.fulfilled, (state) => {
        state.deleting = false
        state.error = null
        state.deleted = true
      })
      .addCase(emptyCalc.rejected, (state, { payload }) => {
        state.deleting = false
        state.error = payload
        state.deleted = false
      })
  },
})

export const { clear } = ordersSlice.actions
export default ordersSlice.reducer
